import { useState } from 'react';

const useRoutingLoader = () => {
  const [routing, setRouting] = useState(false);

  return { routing, setRouting };
};

export default useRoutingLoader;
